import { ApiClient } from "./apiClient";
import { ApiResponse } from "./types";
import {Employee} from "./EmployeeApi";
import {appConfig} from "../config";
import {LeaveType} from "./LeaveTypeApi";


export interface Leave {
    id: string;
    employee: Employee;
    leaveStart: string;
    leaveEnd: string;
    leaveDays: number;
    leaveType: LeaveType;
}

const apiClient = new ApiClient(`${appConfig.backendUrl}/api/leaves`);

/**
 * Fetch all leave types
 */
export const fetchLeavesInYearMonth = (year: number, month: number): Promise<ApiResponse<Leave[]>> => {
    return apiClient.get<Leave[]>(`/${year}/${month}`);
};